import { Inbox } from 'lucide-react';
import { cn } from '../../lib/cn';

// Stan pusty z kontekstem i akcją, zamiast samotnego zdania
// "Brak dodanych kontenerów lub brak wyników dla wybranych filtrów."
// Rozróżnienie "nie ma nic" od "filtry nic nie znalazły" jest tu istotne,
// bo prowadzi do zupełnie innej reakcji użytkownika.

export function EmptyState({ icon: Icon = Inbox, title, description, action, className }) {
  return (
    <div className={cn('flex flex-col items-center justify-center px-6 py-12 text-center', className)}>
      <span className="mb-3 flex h-11 w-11 items-center justify-center rounded-full bg-elevated text-subtle">
        <Icon size={20} />
      </span>
      <p className="text-sm font-medium text-content">{title}</p>
      {description && <p className="mt-1 max-w-sm text-xs text-muted">{description}</p>}
      {action && <div className="mt-4">{action}</div>}
    </div>
  );
}

export default EmptyState;
